import React__default from 'react';
import { TouchableOpacity, Image, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { H as HoverableView } from './index-a9a6637c.esm.js';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';
import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { LinearGradient } from 'expo-linear-gradient';

const AppButtonContent = _ref => {
  let {
    children,
    backgroundColor,
    borderColor,
    start_base_button_colour,
    end_base_button_colour,
    icon,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(LinearGradient, _extends({
    colors: [backgroundColor || start_base_button_colour, backgroundColor || end_base_button_colour],
    style: [style, {
      borderColor: borderColor || "transparent",
      justifyContent: icon ? "flex-start" : "space-evenly",
      alignItems: "center"
    }],
    start: {
      x: 0,
      y: 0
    },
    end: {
      x: 0,
      y: 1
    }
  }, props), children);
};
AppButtonContent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppButtonContent",
  "props": {
    "children": {
      "required": true,
      "tsType": {
        "name": "ReactNode"
      },
      "description": ""
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Required when not using start_base_button_colour and end_base_button_colour.\nAccepts any css color value"
    },
    "borderColor": {
      "required": true,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "start_base_button_colour": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Required when not using backgroundColor. Starting color of the gradient.\nAccepts any css color value"
    },
    "end_base_button_colour": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Required when not using backgroundColor. Ending color of the gradient.\nAccepts any css color value"
    },
    "icon": {
      "required": false,
      "tsType": {
        "name": "union",
        "raw": "IconDefinition | ImageSourcePropType",
        "elements": [{
          "name": "IconDefinition"
        }, {
          "name": "ImageSourcePropType"
        }]
      },
      "description": ""
    },
    "style": {
      "required": true,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    }
  }
};

//@ts-nocheck
function AppButton(_ref) {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4;
  let {
    title = "App btn",
    is_secondary = false,
    onPress,
    icon,
    iconStyle,
    style,
    backgroundColor,
    isDisabled = false,
    borderColor,
    fontColor,
    borderRadius = 10,
    awesomeIcon,
    rightIcon,
    rightIconColor,
    awesomeIconColor,
    btnLabelStyle,
    btnContentStyle,
    awesomeIconSize,
    wrapperStyle,
    ...props
  } = _ref;
  const theme = useTheme();
  const currentTheme = theme === null || theme === void 0 ? void 0 : theme.currentTheme;
  const _btnStyle = btnStyle({
    borderRadius,
    isSecondary: is_secondary,
    fontColor: fontColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.black),
    isMouseOver: false,
    currentTheme
  });
  return /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    accessibilityLabel: props.accessibilityLabel,
    style: [{
      zIndex: -1
    }, wrapperStyle],
    onPress: () => onPress && onPress(),
    disabled: isDisabled
  }, /*#__PURE__*/React__default.createElement(HoverableView, {
    style: [_btnStyle.button, {
      backgroundColor: "transparent"
    }, style],
    onHover: {
      opacity: is_secondary || isDisabled ? 0.9 : 1
    }
  }, /*#__PURE__*/React__default.createElement(AppButtonContent, {
    backgroundColor: isDisabled ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.mediumGrey : backgroundColor,
    borderColor: borderColor,
    icon: icon || awesomeIcon,
    style: [_btnStyle.content, btnContentStyle],
    start_base_button_colour: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.start_base_button_colour,
    end_base_button_colour: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.end_base_button_colour
  }, icon ? /*#__PURE__*/React__default.createElement(Image, {
    style: [_btnStyle.icon, iconStyle],
    source: icon
  }) : awesomeIcon ? /*#__PURE__*/React__default.createElement(AppIcon, {
    color: awesomeIconColor,
    style: _btnStyle.icon,
    icon: awesomeIcon,
    size: awesomeIconSize
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), /*#__PURE__*/React__default.createElement(AppText, {
    fontWeight: "bold",
    style: [_btnStyle.label, btnLabelStyle]
  }, title), rightIcon ? /*#__PURE__*/React__default.createElement(AppIcon, {
    color: rightIconColor,
    style: (_btnStyle.icon, iconStyle),
    icon: rightIcon,
    size: awesomeIconSize
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null))));
}
const btnStyle = _ref2 => {
  var _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8;
  let {
    currentTheme,
    borderRadius,
    isSecondary,
    fontColor,
    isMouseOver
  } = _ref2;
  return StyleSheet.create({
    button: {
      elevation: isSecondary ? 0 : 5,
      marginHorizontal: 5,
      paddingVertical: 0,
      maxWidth: 240,
      height: 60,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.transparent,
      borderRadius: borderRadius || 30,
      shadowOpacity: 0.3,
      shadowRadius: 4.84,
      opacity: 0.9,
      shadowColor: isSecondary ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.transparent : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.shadowColor,
      shadowOffset: {
        width: 3,
        height: 3
      }
    },
    icon: {
      height: 36,
      width: 36,
      marginLeft: 6
    },
    label: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.small_font_size,
      color: fontColor
    },
    content: {
      width: "100%",
      height: "100%",
      borderRadius: 10,
      paddingLeft: 20,
      paddingRight: 20,
      alignItems: "flex-start",
      flexDirection: "row",
      justifyContent: "center",
      borderWidth: 1
    }
  });
};
AppButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppButton",
  "props": {
    "title": {
      "defaultValue": {
        "value": "\"App btn\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Title displayed in button component"
    },
    "is_secondary": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When marked true, it applies default style for secondary button"
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When marked true, the onPres event is not raised and it applies the default disabled style"
    },
    "borderRadius": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Border radius applied to the core button component"
    },
    "onPress": {
      "required": true,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when button is pressed"
    },
    "icon": {
      "required": false,
      "tsType": {
        "name": "union",
        "raw": "IconDefinition | ImageSourcePropType",
        "elements": [{
          "name": "IconDefinition"
        }, {
          "name": "ImageSourcePropType"
        }]
      },
      "description": "When a image uri is passed, the image gets displayed on the left hand side"
    },
    "iconStyle": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "Style applied to the image/icon displayed"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "any"
        }],
        "raw": "StyleProp<any>"
      },
      "description": "Style of view wrapping all sub-components"
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Background color applied to the core button component"
    },
    "borderColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Border color applied to the core button component"
    },
    "fontColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Font color applied to the core button component"
    },
    "awesomeIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "When a fontawesome icon is passed, the icon gets displayed on the left hand side"
    },
    "rightIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "awesomeIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color applied to the fontawesome icon displayed"
    },
    "btnLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "any"
        }],
        "raw": "StyleProp<any>"
      },
      "description": "Style of label displayed in the core button component"
    },
    "btnContentStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "any"
        }],
        "raw": "StyleProp<any>"
      },
      "description": "Style of contents displayed in the core button component"
    },
    "awesomeIconSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Specifies the size of the icon displayed in the button content"
    },
    "wrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "any"
        }],
        "raw": "StyleProp<any>"
      },
      "description": ""
    }
  }
};

export { AppButton as A };
